import React from 'react'

function WarehouseView() {
    return (
        <div>WarehouseView</div>
    )
}

export default WarehouseView